var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.report
      ? _c(
          "div",
          [
            _c(
              "h2",
              { attrs: { tabindex: "-1" } },
              [
                _c("plain-text-control", {
                  attrs: { title: "AupReport.Title" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("attachment-table", {
              attrs: {
                title: "AupReport.Attachments",
                createNewAttachment: _vm.createNewAttachment,
                allowDelete: function() {
                  return true
                }
              },
              model: {
                value: _vm.report.attachments,
                callback: function($$v) {
                  _vm.$set(_vm.report, "attachments", $$v)
                },
                expression: "report.attachments"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }